<template>
  <div>
    <div class="sideways-page-one">
      <!-- BEGIN PAGE BAR -->
      <div class="page-bar">
        <breadcrumb :crumbs="breadcrumbArray" />
      </div>
      <!-- END PAGE BAR -->
      <!-- BEGIN PAGE TITLE-->
      <h1 class="page-title">
        Promo codes
      </h1>
      <!-- END PAGE TITLE -->

      <div class="note note-info">
        <p>Add and manage an application's promo codes.</p>
      </div>

      <!-- BEGIN CREATE NEW PROMO CODE -->
      <div
        v-if="$root.permissions['promocodes create']"
        class="portlet box blue-hoki"
      >
        <div
          class="portlet-title bg-blue-chambray"
          @click="toggleCreatePromoCodePanel()"
        >
          <div class="caption">
            <i class="fa fa-2x fa-plus-circle" />
            Create a New Promo Code
          </div>
          <div class="tools">
            <a :class="{'expand': !createNewPromoCodeCollapse, 'collapse': createNewPromoCodeCollapse}" />
          </div>
        </div>
        <div
          class="portlet-body"
          :class="{'display-hide': createNewPromoCodeCollapse}"
        >
          <form
            role="form"
            @submit.prevent="createNewPromoCode()"
          >
            <div class="form-body row">
              <div class="col-md-12">
                <div
                  v-show="createErrorMessage"
                  ref="createErrorMessage"
                  class="alert alert-danger"
                >
                  <button
                    class="close"
                    @click.prevent="clearError('createErrorMessage')"
                  />
                  <span>{{ createErrorMessage }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-4">
                <div class="form-group form-md-line-input form-md-floating-label">
                  <div class="input-icon right">
                    <input
                      id="form_control_1"
                      v-model="newPromoCode.codes"
                      type="text"
                      class="form-control input-sm  text-uppercase"
                      :class="{'edited': newPromoCode.codes.length}"
                    >
                    <i
                      class="fa fa-magic clickable"
                      aria-hidden="true"
                      @click.prevent="setRandomCode(newPromoCode)"
                    />
                  </div>
                  <label for="form_control_1">
                    Enter a Code
                  </label>
                </div>
                <div class="side-by-side-wrapper">
                  <div class="form-group form-md-line-input form-md-floating-label side-by-side-item margin-right-10">
                    <input
                      id="form_control_2"
                      v-model="newPromoCode.value"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': newPromoCode.value}"
                    >
                    <label for="form_control_2">
                      Value
                    </label>
                  </div>
                  <el-dropdown
                    trigger="click"
                    size="small"
                    :show-timeout="50"
                    :hide-timeout="50"
                    @command="updateNewPromoCodeValueType"
                  >
                    <el-button size="small">
                      {{ newPromoCodeValueTypeLabel }}
                      <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="percentage">
                        %
                      </el-dropdown-item>
                      <el-dropdown-item command="dollar">
                        $
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="side-by-side-wrapper">
                  <el-select
                    v-model="newPromoCode.apply_on"
                    placeholder="Discount is applied to"
                    size="small"
                  >
                    <el-option
                      label="Menu Items"
                      value="items"
                    />
                    <el-option
                      label="Delivery Fee"
                      value="delivery"
                    />
                    <el-option
                      label="Cart"
                      value="cart"
                    />
                  </el-select>
                  <button
                    v-if="newPromoCode.apply_on === 'items'"
                    type="submit"
                    class="btn blue btn-outline margin-left-5 mb-0"
                    @click="displayMenuTreeModal($event)"
                  >
                    <span v-if="!newPromoCode.sku.length">
                      Select
                    </span>
                    <span v-else>
                      Add
                    </span> items
                  </button>
                </div>
                <p
                  v-if="newPromoCode.apply_on === 'items'"
                  class="grey-label margin-left-5"
                >
                  Selected
                  <span>{{ newPromoCode.sku.length }}</span>
                  <span v-if="newPromoCode.sku.length !== 1">
                    items
                  </span>
                  <span v-else>
                    item
                  </span>
                </p>
                <div class="margin-top-15">
                  <el-dropdown
                    trigger="click"
                    size="small"
                    :show-timeout="50"
                    :hide-timeout="50"
                    @command="updateNewPromoCodeType"
                  >
                    <el-button size="small">
                      {{ newPromoCodeTypeLabel }}
                      <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="single_use">
                        Single
                      </el-dropdown-item>
                      <el-dropdown-item command="multi_use">
                        Multi
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="form-group form-md-line-input form-md-floating-label">
                  <input
                    id="form_control_3"
                    v-model="newPromoCode.max_use_per_person"
                    type="text"
                    class="form-control input-sm"
                    :class="{'edited': newPromoCode.max_use_per_person.length}"
                  >
                  <label for="form_control_3">
                    Maximum Redemptions Per User
                  </label>
                </div>
                <div class="form-group form-md-line-input form-md-floating-label narrow-input">
                  <input
                    id="form_control_4"
                    v-model="newPromoCode.max_use"
                    type="text"
                    class="form-control input-sm"
                    :class="{'edited': newPromoCode.max_use.length}"
                  >
                  <label for="form_control_4">
                    Total Redemptions Permitted
                  </label>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-4">
                <div class="form-group form-md-line-input form-md-floating-label narrow-input">
                  <input
                    id="form_control_4"
                    v-model="newPromoCode.description"
                    type="text"
                    class="form-control input-sm"
                    :class="{'edited': newPromoCode.description}"
                  >
                  <label for="form_control_4">
                    Description
                  </label>
                </div>
                <div class="form-group form-md-line-input form-md-floating-label">
                  <p class="date-label">
                    Start Date
                  </p>
                  <el-date-picker
                    v-model="newPromoCode.start_from"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    placeholder="Select start date"
                  />
                </div>
                <div class="form-group form-md-line-input form-md-floating-label">
                  <p class="date-label">
                    End Date
                  </p>
                  <el-date-picker
                    v-model="newPromoCode.end_on"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    placeholder="Select end date"
                  />
                </div>
                <div>
                  <p class="inline margin-right-10">
                    Availability
                  </p>
                  <button
                    type="submit"
                    class="btn blue btn-outline"
                    @click="selectLocations(newPromoCode, $event, 'new')"
                  >
                    Select stores
                  </button>
                  <p
                    v-if="newPromoCode.locations.length"
                    class="grey-label"
                  >
                    Selected
                    <span v-if="newPromoCode.locations === 'all'">
                      all
                    </span>
                    <span v-else>
                      {{ newPromoCode.locations.length }}
                    </span>
                    <span v-if="newPromoCode.locations.length !== 1">
                      stores
                    </span>
                    <span v-else>
                      store
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="form-actions right margin-top-20">
              <div class="row">
                <div class="col-xs-12 col-lg-8">
                  <button
                    type="submit"
                    class="btn blue"
                    :disabled="creating"
                  >
                    Create
                    <i
                      v-show="creating"
                      class="fa fa-spinner fa-pulse fa-fw"
                    />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- END CREATE NEW PROMO CODE -->

      <!-- BEGIN DISPLAY PROMO CODES -->
      <loading-screen
        :show="displayPromoCodesData"
        :color="'#2C3E50'"
        :display="'inline'"
      />
      <div v-if="!displayPromoCodesData">
        <div
          id="promoCodes-container"
          class="portlet light portlet-fit bordered margin-top-20"
        >
          <div class="portlet-title bg-blue-chambray">
            <div class="menu-image-main">
              <img src="../../../public/client_logo.png">
            </div>
            <div class="caption">
              <span class="caption-subject font-default bold uppercase">
                Promo Codes
              </span>
              <div
                v-if="$root.permissions['promocodes update'] || $root.permissions['promocodes delete']"
                class="caption-desc font-grey-cascade"
              >
                Click on a promo code to edit or delete it.
              </div>
              <div
                v-if="$root.permissions['promocodes read'] && !$root.permissions['promocodes update']"
                class="caption-desc font-grey-cascade"
              >
                Click on a promo code to view it.
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-show="assignErrorMessage"
              ref="assignErrorMessage"
              class="alert alert-danger"
            >
              <button
                class="close"
                @click="clearError('assignErrorMessage')"
              />
              <span>{{ assignErrorMessage }}</span>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-12">
                <div
                  v-show="listErrorMessage"
                  ref="listErrorMessage"
                  class="alert alert-danger"
                >
                  <button
                    class="close"
                    @click="clearError('listErrorMessage')"
                  />
                  <span>{{ listErrorMessage }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="promoCodes.length"
              class="mt-element-list margin-top-15"
            >
              <div class="mt-list-container list-news ext-1 no-border">
                <ul>
                  <li
                    v-for="promoCode in promoCodes"
                    :id="'promoCode-' + promoCode.id"
                    :key="`promoCode-${promoCode.id}`"
                    class="mt-list-item actions-at-left margin-top-15 two-vertical-actions"
                    :class="{'animated' : animated === `promoCode-${promoCode.id}`}"
                  >
                    <div class="list-item-actions">
                      <el-tooltip
                        v-if="$root.permissions['promocodes read'] && !$root.permissions['promocodes update']"
                        content="View"
                        effect="light"
                        placement="right"
                      >
                        <a
                          class="btn btn-circle btn-icon-only btn-default"
                          @click="editPromoCode(promoCode, $event)"
                        >
                          <i class="fa fa-lg fa-eye" />
                        </a>
                      </el-tooltip>
                      <el-tooltip
                        v-if="$root.permissions['promocodes update']"
                        content="Edit"
                        effect="light"
                        placement="right"
                      >
                        <a
                          class="btn btn-circle btn-icon-only btn-default"
                          @click="editPromoCode(promoCode, $event)"
                        >
                          <i class="fa fa-lg fa-pencil" />
                        </a>
                      </el-tooltip>
                      <el-tooltip
                        v-if="$root.permissions['promocodes delete']"
                        content="Delete"
                        effect="light"
                        placement="right"
                      >
                        <a
                          class="btn btn-circle btn-icon-only btn-default"
                          @click="deletePromoCode(promoCode, $event)"
                        >
                          <i class="fa fa-lg fa-trash" />
                        </a>
                      </el-tooltip>
                    </div>
                    <div class="list-item-content height-mod">
                      <div class="col-sm-4">
                        <div class="bold uppercase font-red">
                          <span>{{ promoCode.codes }}</span>
                        </div>
                        <div>
                          <strong>Value: </strong>
                          <span v-if="promoCode.value_type === 'dollar'">
                            $
                          </span>
                          <span>{{ promoCode.value }}</span>
                          <span v-if="promoCode.value_type === 'percentage'">
                            %
                          </span>
                        </div>
                        <div>
                          <strong>Applies to: </strong>
                          <span>{{ promoCode.apply_on }}</span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="">
                          <strong>Type: </strong>
                          <span>{{ promoCode.type }}</span>
                        </div>
                        <div>
                          <strong>Total Redemptions: </strong>
                          <span>{{ promoCode.max_use }}</span>
                        </div>
                        <div>
                          <strong>Max Per User: </strong>
                          <span>{{ promoCode.max_use_per_person }}</span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <strong>Start: </strong>
                          <span>{{ promoCode.start_from }}</span>
                        </div>
                        <div>
                          <strong>End: </strong>
                          <span>{{ promoCode.end_on }}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              v-if="!promoCodes.length && !displayPromoCodesData"
              class="margin-top-20"
            >
              <no-results
                :show="!promoCodes.length"
                :type="'promo codes'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END DISPLAY PROMO CODES -->

    <!-- MENU ITEM PICKER MODAL START -->
    <modal
      :show="showMenuTreeModal"
      effect="fade"
      :width="900"
      @closeOnEscape="closeMenuTreeModal"
    >
      <div
        slot="modal-header"
        class="modal-header"
      >
        <button
          type="button"
          class="close"
          @click="closeMenuTreeModal()"
        >
          <span>&times;</span>
        </button>
        <h4 class="modal-title center">
          Select Items
        </h4>
      </div>
      <div
        slot="modal-body"
        class="modal-body"
      >
        <menu-and-modifier-item-picker
          :previously-selected="newPromoCode.sku"
          @update="itemsSelected"
        />
      </div>
      <div
        slot="modal-footer"
        class="modal-footer"
      >
        <button
          type="button"
          class="btn btn-primary"
          @click="closeMenuTreeModal()"
        >
          Save
        </button>
      </div>
    </modal>
    <!-- MENU ITEM PICKER MODAL END -->

    <select-location
      v-if="showSelectLocationModal"
      :promo-code="passedPromoCode"
      @closeSelectLocationModal="closeSelectLocationModal"
    />

    <edit-promoCode
      v-if="showEditPromoCodeModal"
      :promo-code-id="passedPromoCode.id"
      @updatePromoCode="updatePromoCode"
      @closeEditPromoCodeModal="closeEditPromoCodeModal"
    />

    <delete-promoCode
      v-if="deletePromoCodeModalActive"
      :selected-promo-code-id="selectedPromoCodeId"
      @closeDeletePromoCodeModal="closeDeletePromoCodeModal"
      @deletePromoCodeAndCloseModal="deletePromoCodeAndCloseModal"
    />
  </div>
</template>

<script>
import Breadcrumb from '../modules/Breadcrumb'
import LoadingScreen from '../modules/LoadingScreen'
import PromoCodesFunctions from '../../controllers/PromoCodes'
import Modal from '../modules/Modal'
import Dropdown from '../modules/Dropdown'
import NoResults from '../modules/NoResults'
import EditPromoCode from './PromoCodes/EditPromoCode'
import DeletePromoCode from './PromoCodes/DeletePromoCode'
import SelectLocation from './PromoCodes/SelectLocation'
import MenuAndModifierItemPicker from '@/components/modules/MenuAndModifierItemPicker'
import ajaxErrorHandler from '@/controllers/ErrorController'
import { isNonNegativeNumber } from '@/controllers/utils'

export default {
  components: {
    Breadcrumb,
    LoadingScreen,
    Modal,
    NoResults,
    EditPromoCode,
    DeletePromoCode,
    Dropdown,
    SelectLocation,
    MenuAndModifierItemPicker
  },
  data () {
    return {
      breadcrumbArray: [{ name: 'Promo codes', link: false }],
      displayPromoCodesData: false,
      promoCodes: [],
      createErrorMessage: '',
      listErrorMessage: '',
      assignErrorMessage: '',
      createNewPromoCodeCollapse: true,
      creating: false,
      newPromoCode: {
        apply_on: '',
        codes: '',
        end_on: '',
        locations: [],
        max_use: '',
        max_use_per_person: '',
        sku: [],
        start_from: '',
        type: '',
        value: '',
        value_type: '',
        description: ''
      },
      editedPromoCode: {},
      showGalleryModal: false,
      showEditPromoCodeModal: false,
      selectedPromoCodeId: 0,
      deletePromoCodeModalActive: false,
      showSidewaysPageTwo: false,
      passedPromoCode: {},
      animated: '',
      showSelectLocationModal: false,
      showMenuTreeModal: false
    }
  },
  computed: {
    newPromoCodeValueTypeLabel () {
      if (this.newPromoCode.value_type === 'percentage') {
        return '%'
      } else if (this.newPromoCode.value_type === 'dollar') {
        return '$'
      } else {
        return '$ or %'
      }
    },
    newPromoCodeTypeLabel () {
      if (this.newPromoCode.type === 'single_use') {
        return 'Single'
      } else if (this.newPromoCode.type === 'multi_use') {
        return 'Multi'
      } else {
        return 'Single or Multi Use?'
      }
    }
  },
  mounted () {
    this.getAllPromoCodes()
  },
  methods: {
    /**
     * To update selection of items
     * @function
     * @param {array} items - Array of SKUs of items selected by user
     * @returns {undefined}
     */
    itemsSelected (items) {
      this.newPromoCode.sku = items
    },
    /**
     * To generate a random string from the characters provided
     * @function
     * @param {ingeger} length - The length of the string provided]
     * @param {string} chars - All the characters allowed in the string
     * @returns {string} A random string of the length provided
     */
    randomString (length, chars) {
      var result = ''
      for (var i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)]
      }
      return result
    },
    /**
     * To set the promo code to a random 6 digit all caps alphanumeric string
     * @function
     * @param {object} code - The code object to modify
     * @returns {undefined}
     */
    setRandomCode (code) {
      code.codes = this.randomString(
        6,
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      )
    },
    /**
     * To update the value_type property of newPromoCode.
     * @function
     * @param {object} value - The new value to assign.
     * @returns {undefined}
     */
    updateNewPromoCodeValueType (value) {
      this.newPromoCode.value_type = value
    },
    /**
     * To update the type property of newPromoCode.
     * @function
     * @param {object} value - The new value to assign.
     * @returns {undefined}
     */
    updateNewPromoCodeType (value) {
      if (value === 'single_use') {
        this.newPromoCode.max_use_per_person = '1'
      }
      this.newPromoCode.type = value
    },
    /**
     * To display the modal to select items.
     * @function
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    displayMenuTreeModal (event) {
      event.preventDefault()
      if (!this.$root.activeLocation.id) {
        this.showLocationAlert()
        return
      }
      this.showMenuTreeModal = true
    },
    /**
     * To display a prompt to select a location.
     * @function
     * @returns {undefined}
     */
    showLocationAlert () {
      this.$swal({
        title: 'No location',
        text: 'Please select a store from the stores panel first.',
        type: 'warning',
        confirmButtonText: 'OK'
      })
    },
    /**
     * To close the menu tree modal.
     * @function
     * @param {object} items - An object containing the selected items
     * @returns {undefined}
     */
    closeMenuTreeModal (items) {
      this.showMenuTreeModal = false
    },
    /**
     * To close anything active in the side panel
     * @function
     * @param {object} selectedLocations - The array of selected locations
     * @returns {undefined}
     */
    closeSelectLocationModal (selectedLocations) {
      if (selectedLocations) {
        this.newPromoCode.locations = selectedLocations
      }
      this.showSelectLocationModal = false
    },
    /**
     * To activate the right half panel which lists the store locations.
     * @function
     * @param {object} promoCode - The selected promoCode
     * @param {object} event - The click event that triggered the function
     * @returns {undefined}
     */
    selectLocations (promoCode, event) {
      event.preventDefault()
      this.passedPromoCode = promoCode
      this.showSelectLocationModal = true
    },
    /**
     * To display the modal for deleting a promoCode.
     * @function
     * @param {object} promoCode - The selected promoCode
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    deletePromoCode (promoCode, event) {
      event.stopPropagation()
      this.selectedPromoCodeId = promoCode.id
      this.deletePromoCodeModalActive = true
    },
    /**
     * To close the modal for deleting a promoCode.
     * @function
     * @returns {undefined}
     */
    closeDeletePromoCodeModal () {
      this.deletePromoCodeModalActive = false
    },
    /**
     * To close the modal for deleting a promoCode and remove that promoCode from DOM.
     * @function
     * @returns {undefined}
     */
    deletePromoCodeAndCloseModal () {
      this.deletePromoCodeModalActive = false
      this.getAllPromoCodes()
    },
    /**
     * To show the modal to edit a promo code's details.
     * @function
     * @param {object} promoCode - The selected promo code object.
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    editPromoCode (promoCode, event) {
      event.stopPropagation()
      if (!this.$root.activeLocation.id) {
        this.showLocationAlert()
        return
      }
      this.passedPromoCode = promoCode
      this.showEditPromoCodeModal = true
    },
    /**
     * To get a list of all promoCodes.
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getAllPromoCodes () {
      this.displayPromoCodesData = true
      this.promoCodes = []
      var promoCodesVue = this
      return PromoCodesFunctions.getAllPromoCodes(
        promoCodesVue.$root.appId,
        promoCodesVue.$root.appSecret,
        promoCodesVue.$root.userToken
      )
        .then(response => {
          if (response.code === 200 && response.status === 'ok') {
            promoCodesVue.displayPromoCodesData = false
            promoCodesVue.promoCodes = response.payload
            for (
              var i = 0;
              i < promoCodesVue.promoCodes.length;
              i++
            ) {
              promoCodesVue.$set(
                promoCodesVue.promoCodes[i],
                'selected',
                false
              )
            }
          } else {
            promoCodesVue.displayPromoCodesData = false
          }
        })
        .catch(reason => {
          promoCodesVue.displayPromoCodesData = false
          ajaxErrorHandler({
            reason,
            errorText: 'We could not fetch promocodes',
            errorName: 'listErrorMessage',
            vue: promoCodesVue
          })
        })
    },
    /**
     * To close the modal for editing a promoCode.
     * @function
     * @returns {undefined}
     */
    closeEditPromoCodeModal () {
      this.showEditPromoCodeModal = false
    },
    /**
     * To clear the new promoCode form.
     * @function
     * @returns {undefined}
     */
    clearNewPromoCode () {
      this.newPromoCode = {
        apply_on: '',
        codes: '',
        end_on: '',
        locations: [],
        max_use: '',
        max_use_per_person: '',
        sku: [],
        start_from: '',
        type: '',
        value: '',
        value_type: '',
        description: ''
      }
    },
    /**
     * To check if a date is in the past.
     * @function
     * @param {string} date - The date string to verify.
     * @returns {boolean} True if date is in the past, false if not
     */
    isPast (date) {
      let input = new Date(date)
      input.setMinutes(input.getMinutes() + input.getTimezoneOffset())
      let today = new Date()
      let inputDay = input.getDate()
      if (inputDay < 10) {
        inputDay = '0' + inputDay
      }
      let inputMonth = input.getMonth()
      if (inputMonth < 10) {
        inputMonth = '0' + inputMonth
      }
      let inputYear = input.getFullYear()
      let todayDay = today.getDate()
      if (todayDay < 10) {
        todayDay = '0' + todayDay
      }
      let todayMonth = today.getMonth()
      if (todayMonth < 10) {
        todayMonth = '0' + todayMonth
      }
      let todayYear = today.getFullYear()

      return (
        `${todayYear}-${todayMonth}-${todayDay}` >
        `${inputYear}-${inputMonth}-${inputDay}`
      )
    },

    /**
     * To check if the promo code data is valid before submitting to the backend.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    validatePromoCodeData () {
      var promoCodesVue = this
      return new Promise(function (resolve, reject) {
        if (!promoCodesVue.newPromoCode.codes.length) {
          reject('Code cannot be blank')
        } else if (!isNonNegativeNumber(promoCodesVue.newPromoCode.value)) {
          reject('Value Of Promo Code must be zero or more')
        } else if (!promoCodesVue.newPromoCode.value_type.length) {
          reject('Value Type cannot be blank')
        } else if (!promoCodesVue.newPromoCode.apply_on.length) {
          reject('Discount Is Applied To cannot be blank')
        } else if (
          promoCodesVue.newPromoCode.apply_on === 'items' &&
          promoCodesVue.newPromoCode.sku.length === 0
        ) {
          reject('Select at least one item')
        } else if (!promoCodesVue.newPromoCode.type.length) {
          reject('Single or Multi Use cannot be blank')
        } else if (!isNonNegativeNumber(promoCodesVue.newPromoCode.max_use_per_person)) {
          reject('Maximum Redemptions Per User must be zero or more')
        } else if (!isNonNegativeNumber(promoCodesVue.newPromoCode.max_use)) {
          reject('Total Redemptions Permitted must be zero or more')
        } else if (promoCodesVue.newPromoCode.max_use < promoCodesVue.newPromoCode.max_use_per_person) {
          reject('Total Redemptions Permitted cannot be smaller than Maximum Redemptions Per User')
        } else if (!promoCodesVue.newPromoCode.description) {
          reject('Description cannot be blank')
        } else if (!promoCodesVue.newPromoCode.start_from.length) {
          reject('Please select Start Date')
        } else if (promoCodesVue.isPast(promoCodesVue.newPromoCode.start_from)) {
          reject('Start Date cannot be in the past')
        } else if (!promoCodesVue.newPromoCode.end_on.length) {
          reject('Please select End Date')
        } else if (promoCodesVue.isPast(promoCodesVue.newPromoCode.end_on)) {
          reject('End Date cannot be in the past')
        } else if (new Date(promoCodesVue.newPromoCode.end_on) < new Date(promoCodesVue.newPromoCode.start_from)) {
          reject('End Date cannot be before Start Date')
        } else if (!promoCodesVue.newPromoCode.locations.length) {
          reject('Select at least one location')
        }
        resolve('Hurray')
      })
    },
    /**
     * To create a new promoCode.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    createNewPromoCode () {
      var promoCodesVue = this
      promoCodesVue.clearError('createErrorMessage')

      return promoCodesVue
        .validatePromoCodeData()
        .then(response => {
          promoCodesVue.creating = true
          let newPromoCode = { ...promoCodesVue.newPromoCode }
          newPromoCode.codes = newPromoCode.codes.toUpperCase()

          PromoCodesFunctions.createNewPromoCode(
            promoCodesVue.newPromoCode,
            promoCodesVue.$root.appId,
            promoCodesVue.$root.appSecret,
            promoCodesVue.$root.userToken
          )
            .then(response => {
              if (
                response.code === 200 &&
                response.status === 'ok'
              ) {
                promoCodesVue.getAllPromoCodes()
                promoCodesVue.showAlert(response.payload)
                promoCodesVue.clearNewPromoCode()
              } else {
                promoCodesVue.createErrorMessage =
                  response.message
              }
            })
            .catch(reason => {
              ajaxErrorHandler({
                reason,
                errorText: 'We could not add the promocode',
                errorName: 'createErrorMessage',
                vue: promoCodesVue
              })
            })
            .finally(() => {
              promoCodesVue.creating = false
            })
        })
        .catch(reason => {
          // If validation fails then display the error message
          promoCodesVue.createErrorMessage = reason
          window.scrollTo(0, 0)
          throw reason
        })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showAlert (payload = {}) {
      let title = 'Success'
      let text = 'The Promocode has been created'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The Promocode has been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To update the promoCode info.
     * @function
     * @param {object} promoCode - The promoCode object that is to be updated.
     * @returns {undefined}
     */
    updatePromoCode (promoCode) {
      this.displayEditPromoCodeModal = false
      this.getAllPromoCodes()
    },
    /**
     * To clear the current error.
     * @function
     * @param {object} errorMessageName - The error message to be cleared.
     * @returns {undefined}
     */
    clearError (errorMessageName) {
      this[errorMessageName] = ''
    },
    /**
     * To toggle the create tier panel, initially set to closed
     * @function
     * @returns {undefined}
     */
    toggleCreatePromoCodePanel () {
      this.createNewPromoCodeCollapse = !this.createNewPromoCodeCollapse
    },
    /**
     * To open the gallery modal.
     * @function
     * @returns {undefined}
     */
    openGalleryPopup () {
      this.showGalleryModal = true
    },
    /**
     * To close the gallery popup.
     * @function
     * @returns {undefined}
     */
    closeGalleryModal () {
      this.showGalleryModal = false
    },
    /**
     * To set the image to be same as the one emitted by the gallery modal.
     * @function
     * @param {object} val - The emitted image object.
     * @returns {undefined}
     */
    updateImage (val) {
      this.showGalleryModal = false
      this.newPromoCode.image = val.image_url
    }
  }
}
</script>

<style scoped>
.sideways-page-one.disabled {
  overflow: hidden;
}
.sideways-page-two {
  overflow-y: scroll;
}
.dropdown {
  margin-bottom: 10px;
}
.side-by-side-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.side-by-side-item {
  max-width: 45%;
}
.dropdown.side-by-side-item {
  margin-left: 10px;
}
.date-label {
  color: rgb(136, 136, 136);
  font-size: 13px;
  margin-bottom: 5px;
}
.grey-label {
  color: rgb(153, 153, 153);
}
.mb-0 {
  margin-bottom: 0;
}
.mt-element-list
  .list-news.ext-1.mt-list-container
  ul
  > .mt-list-item
  > .list-datetime,
.mt-element-list
  .list-news.ext-1.mt-list-container
  ul
  > .mt-list-item
  > .list-item-content {
  padding-left: 20px;
}
.animated {
  animation: listItemHighlight 1s 2 ease-in-out both;
}
.mt-element-list .list-news.ext-1.mt-list-container ul > .mt-list-item:hover {
  background-color: white;
}
.two-vertical-actions {
  min-height: 90px;
}
</style>
